import { useUpsellsStore } from '@/features/cart/plugins/UpsellsPlugin/stores/upsellsStore'
import type { RecommendationsModel } from '@/features/cart/plugins/UpsellsPlugin/stores/upsellsStore'
import { useEffect } from 'react'

export const useCartUpsells = () => {
  const { upsells, isLoading, error, setModel } = useUpsellsStore((state) => ({
    setModel: state.setModel,
    upsells: state.upsells,
    isLoading: state.isLoading,
    error: state.error,
  }))

  return { upsells, isLoading, error, setModel }
}
